<template>
  <RouterView />
</template>

<script>
export default {
  name: 'Vacancy',
};
</script>
